<template>
  <div>
    <ProjectPlannedResourcesResponsibleAndSubscribersWrap
      v-if="responsibleAccess && companiesConfig.responsible_person !== '0'"
      type="responsible"
      :edit="edit"
      class="mb-8"
    />
    <ProjectPlannedResourcesResponsibleAndSubscribersWrap
      v-if="subscribersAccess && companiesConfig.subscribers !== '0'"
      type="subscribers"
      :edit="edit"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProjectPlannedResourcesResponsibleAndSubscribersWrap from './ProjectPlannedResourcesResponsibleAndSubscribersWrap'

export default {
  name: 'ProjectPlannedResourcesResponsibleAndSubscribers',
  props: {
    edit: Boolean,
    createContinue: Boolean,
    projectRequiredData: Object,
  },
  components: {
    ProjectPlannedResourcesResponsibleAndSubscribersWrap,
  },
  created() {
    this.onDownloadComponentData('responsible')
    this.onDownloadComponentData('subscriber')
  },
  watch: {
    responsibleAccess() {
      this.onDownloadComponentData('responsible')
    },
    subscribersAccess() {
      this.onDownloadComponentData('subscriber')
    },
  },
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapGetters('user', ['userType', 'userData']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    responsibleAccess() {
      return (
        this.userType === 'subscriber' ||
        this.$userCheckAccess({
          abilities: 'view_project_responsible',
        })
      )
    },
    subscribersAccess() {
      return (
        this.userType !== 'subscriber' &&
        this.$userCheckAccess({
          abilities: 'view_project_subscribers',
        }) &&
        this.workClientProjectShow &&
        (this.workClientProjectShow.status == 'in_progress' ||
          this.workClientProjectShow.status == 'done')
      )
    },
  },
  methods: {
    ...mapActions('workClientProjectsResponsibleEmployees', [
      'onWorkClientProjectsResponsibleEmployeesAll_project',
    ]),
    ...mapActions('workClientProjectsSubscribers', ['onWorkClientProjectsSubscribersAll_project']),
    onDownloadComponentData(type) {
      if (this.$route.name !== 'SalesProjectCreate') {
        if (this.responsibleAccess && type === 'responsible') {
          this.onWorkClientProjectsResponsibleEmployeesAll_project({
            project_id: this.$route.params.id,
          })
        }
        if (this.subscribersAccess && type === 'subscriber') {
          this.onWorkClientProjectsSubscribersAll_project({
            project_id: this.$route.params.id,
          })
        }
      }
    },
  },
}
</script>
